import React, { EventHandler } from 'react';
import { TestResultType2Bypass } from '@ecosconnect/core/src/types/jobFormData';
import AccordionItem from '../../../Accordion/AccordionItem';
import { Input } from '../../../Form';

type Type2BypassTestResultEditProps = {
  test: TestResultType2Bypass;
  onFormInputChange: EventHandler<any>;
};

const Type2BypassTestResultEdit: React.FC<Type2BypassTestResultEditProps> = ({
  test,
  onFormInputChange,
}) => {
  return (
    <AccordionItem
      label="Bypass Check"
      alignItems="center"
      as="label"
      value={
        <Input
          onChange={onFormInputChange}
          required
          variant="accordion"
          type="number"
          name="bypassCheck"
          value={test.bypassCheck}
          step="0.1"
          min="0"
          max="200"
          autoComplete="off"
        />
      }
    />
  );
};

export default Type2BypassTestResultEdit;
